// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const reCAPTCHALangs = {
   "ar-AR": "ar",
   "br-PT": "pt-BR",
   "ca-ES": "ca",
   "cs-CZ": "cs",
   "da-DK": "da",
   "de-DE": "de",
   "en-AU": "en-GB",
   "en-NZ": "en-GB",
   "en-UK": "en-GB",
   "en": "en",
   "es-ES": "es",
   "fa-FA": "fa",
   "fi-FI": "fi",
   "fr-CA": "fr-CA",
   "fr-FR": "fr",
   "gb-CY": "en-GB",
   "gr-GR": "el",
   "he-HE": "iw",
   "is-IS": "is",
   "it-IT": "it",
   "jp": "ja",
   "ko-KO": "ko",
   "mi-NZ": "en-GB",
   "ms-MY": "ms",
   "nl-NL": "nl",
   "no-NO": "no",
   "pl": "pl",
   "pt-PT": "pt",
   "ru-RU": "ru",
   "sv-SE": "sv",
   "th-TH": "th",
   "tu-TU": "tr",
   "za-CN": "zh-TW",
   "zh-CN": "zh-CN"
}

angular.module('summonApp.constants')
   .constant('$reCAPTCHALangs', reCAPTCHALangs)
